var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c("div", { staticClass: "d-flex gap-5 groups" }, [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize unitType" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("End of Time Unit Type"),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: { items: _vm.unitTypes, idKey: "id", labelKey: "label" },
            model: {
              value: _vm.clone.endOf.unit,
              callback: function ($$v) {
                _vm.$set(_vm.clone.endOf, "unit", $$v)
              },
              expression: "clone.endOf.unit",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "From Timezone" },
          model: {
            value: _vm.clone.endOf.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.endOf, "fromTimezone", $$v)
            },
            expression: "clone.endOf.fromTimezone",
          },
        }),
        _vm._v(" "),
        _c("TimezonePickerInput", {
          attrs: { title: "To Timezone" },
          model: {
            value: _vm.clone.endOf.toTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.endOf, "toTimezone", $$v)
            },
            expression: "clone.endOf.toTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.endOf.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.endOf, "fromFormat", $$v)
            },
            expression: "clone.endOf.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "To Format" },
          model: {
            value: _vm.clone.endOf.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.endOf, "toFormat", $$v)
            },
            expression: "clone.endOf.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.endOf.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.endOf, "fromLocale", $$v)
            },
            expression: "clone.endOf.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "To Locale" },
          model: {
            value: _vm.clone.endOf.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.endOf, "toLocale", $$v)
            },
            expression: "clone.endOf.toLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }